import type {ComponentProps} from "react";
import {AnankeDropdownMenu} from "@vesta/ananke/components/anankeDropdownMenu";
import {AnankeIconButton} from "@vesta/ananke/components/anankeIconButton";

export function AnankeTempDropdownMenuWithIconButtonTrigger({
    iconButtonProps,
    ...props
}: ComponentProps<typeof AnankeDropdownMenu> & {
    trigger?: undefined;
    iconButtonProps: ComponentProps<typeof AnankeIconButton>;
}) {
    return (
        <AnankeDropdownMenu<HTMLButtonElement>
            {...props}
            trigger={({triggerRef, ...props}) => (
                <AnankeIconButton
                    {...props}
                    {...iconButtonProps}
                    ref={triggerRef}
                />
            )}
        />
    );
}
